import toastMessage from "../../utils/toastMessage";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchServiceAccounts = async (lng = "english", params) => {
  const { listType } = params || {};
  const { accessToken } = await getStorage();

  if (!accessToken) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    authorization:
      "Bearer eyJraWQiOiIwYjU3NGNjZi0xNTU0LTRiMWMtODRlMC1iMzkwOTk0Nzc0ZmEiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIwZTI1NzdlYS1hZWQ1LTExZWUtYTUwNi0wMjQyYWMxMjAwMDIiLCJyb2xlcyI6WyJNRVJDSEFOVCJdLCJpc3MiOiJodHRwczovL3Nzby5tb2JpdGlsbC5jb20vdWF0L2FwaS92MSIsImF1dGhvcml0aWVzIjpbIlJFQUQiLCJQUk9GSUxFIiwiQ1JFQVRFIiwiVVBEQVRFIl0sImF1ZCI6IjBlMjU3N2VhLWFlZDUtMTFlZS1hNTA2LTAyNDJhYzEyMDAwMiIsIm5iZiI6MTcxNzA1MjA0Miwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSIsInJvbGVOYW1lIjoiTUVSQ0hBTlQiLCJ0ZW5hbnRJZCI6InRlcWdpVU9TZEd3emhpZFRCTGRmR3Zja21LV3ZGa0RYdmdmIiwidXNlclB1YmxpY0lkIjoiZmJiNTBjNjMtYjgyMy00OTA4LWE3OTMtYjNjNGZkZmNlZmNhIiwicHJvZmlsZVB1YmxpY0lkIjoiYTdkOTg2MGYtYTMwYy00MTA5LWE2MGQtYzIzNmZmNDk5MDJjIiwiZXhwIjoxNzE3MTM4NDQyLCJpYXQiOjE3MTcwNTIwNDIsImp0aSI6ImY0MjQ2NmQ3LTkyMmYtNGI3OC1iMWJhLTY5YzFkZTUyMjQxOCIsInVzZXJuYW1lIjoicnVidWEzMUBnbWFpbC5jb20ifQ.a2GqrGlGXvHxVP7KTinsrz142YPCLCUzAmbjm71E1kEJAiRWXp8igRUi-yS8T7QfmpJR0H6jEpczwGGOifB2nly5tOnTS6E-AbrrOoPULdOlXDxYoFrHOYj8S2XQsquKbq3eDkBTZiIAm-iyOxrjK_kDkWH8_Y7vSNHXcrkyYuYg8jlZGZX3SCmFeTBNG43EcSF76apGq7yaFihQmaErUWGPwQIqzVdQjKqDUx5GKLXcpDEntBMHKGtCIVCiT-hT0hYog1UuaqlYpCGwMvZoouguvniskDjkx4_KZBHge7I8PLGYXixxoUCealCwLp4iVh2jZI1dJNqY3b_LyemwNw",
    // + accessToken,
  };

  try {
    const options = {
      method: "GET",
      url: `${process.env.REACT_APP_DEVELOPMENT_INVOICE_API}/serviceAccounts`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "publicId");
    }

    let results = data.data;

    return results;
  } catch (error) {
    toastMessage("error", error);
  }
};
